<template>
	<div class="container page">
		<div class="header">
			<van-nav-bar :title="$t('recharge.recharge')" class="nav-bar">
				<template #left>
					<van-icon name="arrow-left" color="#fff" @click="back()" />
				</template>
			</van-nav-bar>
			<div class="info">
				<p class="title">
					{{ $t("other.current_balance") }}({{ $currency }})
				</p>
				<p class="value">{{ this.balance }}</p>
			</div>
			<div class="content recharge">
				<van-form @submit="onSubmit">
					<div class="form-item">
						<div class="form-item-title">{{ $t("other.input_recharge_amount") }}</div>
						<div style="height: 65px">
							<van-field v-model="money" name="money" :placeholder="$t('recharge.input_money')" />
						</div>
					</div>
					<van-button round block type="info" native-type="submit" class="nav-bar"
						style="border: 0px solid #000;">{{ $t("other.introduction") }}</van-button>
				</van-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				balance: 0,
				money: "",
			};
		},
		created() {},
		mounted() {
			this.getUserInfo()
		},
		methods: {
			back() {
				return window.history.back();
			},
			//拉起支付
			onSubmit() {
				this.$router.push({
					path: `ServiceOnline`
				});
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 1) {
						this.balance = res.data.user_money;
					} else {
						this.$toast(res.msg);
					}
				})
			},
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.container .header {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.recharge {
		padding: 10px 30px;
	}

	.van-cell {
		line-height: 65px !important;
	}

	.van-button {
		height: 87px !important;
	}

	.van-button__text {
		color: #fff !important;
	}

	/deep/.van-radio__icon {
		font-size: 30px !important;
	}

	/deep/.van-radio__label {
		margin-left: 25px !important;
		font-size: 35px !important;
	}

	/deep/ .van-field__control {
		font-size: 36px !important;
	}

	/deep/.van-radio {
		height: 65px !important;
	}

	.form-item {
		margin-top: 40px;
	}

	.form-item-title {
		font-size: 36px;
		font-weight: bold;
		color: #999;
		margin-bottom: 20px;
	}

	.recharge span {
		font-size: 4vw;
		color: #868686;
		font-weight: 500;
	}

	.container .header .info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 20px;
		padding-top: 10px;
		margin: auto;
	}

	.container .header .info .title {
		font-size: 25px;
		color: #e5e5e5;
	}

	.container .header .info .value {
		margin: 10px auto;
		color: #fff;
		font-size: 50px;
		border-bottom: 1px solid #fff;
	}

	.container .header .info .tip {
		font-size: 30px;
		color: #e5e5e5;
	}

	.container .content {
		flex: 1;
		background: #f2f2f5;
	}
</style>